import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const FormGroup = ({ className = '', children, error = '' }) => (
  <div className={cn('form-group', className)} data-error={error}>
    {children}
  </div>
);

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
};


export default FormGroup;
